import { html } from 'htm/preact';
import { useState } from 'preact/hooks';

const Attribute = ({ name, value }) => {
  const [isCopied, setIsCopied] = useState(false);
  const hasClipboard = !!navigator.clipboard;

  const handleCopy = (e) => {
    e.preventDefault();
    navigator.clipboard.writeText(value);
    setIsCopied(true);

    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  };

  return html`
    <div class="mb-3 w-full">
      <h5 class="text-xs mb-1 uppercase">${name}</h5>

      <button
        class="flex items-center justify-between w-full font-bold font-serif text-xs rounded-3xl border border-gray-200 p-1 pl-4"
        onClick=${handleCopy}
      >
        <span>${value}</span>
        ${hasClipboard
          ? html`
              <span class="flex items-center gap-1 bg-yellow text-purple rounded-3xl py-1 px-2.5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="11"
                  height="11"
                  viewBox="0 0 11 11"
                  fill="currentColor"
                  class="w-3"
                >
                  <path
                    d="M2.75 9.05217H1.83333C1.62069 9.05191 1.41682 8.96732 1.26646 8.81695C1.1161 8.66659 1.03151 8.46273 1.03125 8.25008V1.37508C1.03151 1.16243 1.1161 0.958572 1.26646 0.808208C1.41682 0.657844 1.62069 0.573256 1.83333 0.572998H7.79167C8.00431 0.573256 8.20818 0.657844 8.35854 0.808208C8.5089 0.958572 8.59349 1.16243 8.59375 1.37508V2.29175C8.59375 2.38292 8.55753 2.47035 8.49307 2.53482C8.4286 2.59928 8.34117 2.6355 8.25 2.6355C8.15883 2.6355 8.0714 2.59928 8.00693 2.53482C7.94247 2.47035 7.90625 2.38292 7.90625 2.29175V1.37508C7.90589 1.3448 7.89371 1.31587 7.87229 1.29445C7.85088 1.27304 7.82195 1.26086 7.79167 1.2605H1.83333C1.80305 1.26086 1.77412 1.27304 1.75271 1.29445C1.73129 1.31587 1.71911 1.3448 1.71875 1.37508V8.25008C1.71911 8.28036 1.73129 8.3093 1.75271 8.33071C1.77412 8.35212 1.80305 8.36431 1.83333 8.36467H2.75C2.84117 8.36467 2.9286 8.40088 2.99307 8.46535C3.05753 8.52981 3.09375 8.61725 3.09375 8.70842C3.09375 8.79958 3.05753 8.88702 2.99307 8.95148C2.9286 9.01595 2.84117 9.05217 2.75 9.05217Z"
                  />
                  <path
                    d="M9.16667 10.4272H3.20833C2.99569 10.4269 2.79182 10.3423 2.64146 10.192C2.4911 10.0416 2.40651 9.83773 2.40625 9.62508V2.75008C2.40651 2.53743 2.4911 2.33357 2.64146 2.18321C2.79182 2.03284 2.99569 1.94826 3.20833 1.948H9.16667C9.37931 1.94826 9.58318 2.03284 9.73354 2.18321C9.8839 2.33357 9.96849 2.53743 9.96875 2.75008V9.62508C9.96849 9.83773 9.8839 10.0416 9.73354 10.192C9.58318 10.3423 9.37931 10.4269 9.16667 10.4272ZM3.20833 2.6355C3.17796 2.63556 3.14885 2.64765 3.12737 2.66912C3.1059 2.6906 3.09381 2.71971 3.09375 2.75008V9.62508C3.09381 9.65545 3.1059 9.68456 3.12737 9.70604C3.14885 9.72752 3.17796 9.73961 3.20833 9.73967H9.16667C9.19704 9.73961 9.22615 9.72752 9.24762 9.70604C9.2691 9.68456 9.28119 9.65545 9.28125 9.62508V2.75008C9.28119 2.71971 9.2691 2.6906 9.24762 2.66912C9.22615 2.64765 9.19704 2.63556 9.16667 2.6355H3.20833Z"
                  />
                </svg>
                <span>${isCopied ? 'Copied!' : 'Copy'}</span>
              </span>
            `
          : ''}
      </button>
    </div>
  `;
};

export default Attribute;
